import { type FC } from 'react';
import {
  Flex,
  Heading,
  Image,
  Text,
  ValueProp,
  type LucideIconName,
} from '@highereducation/hen-ui';

export interface ResultsBannerProps {
  header: string;
  desktopSubheader: string;
  mobileSubheader: string;
  listItem1: string;
  listItem2: string;
  listItem3: string;
  imageUrl: string;
  showImage: boolean;
}

const ResultsBanner: FC<ResultsBannerProps> = ({
  header,
  desktopSubheader,
  mobileSubheader,
  listItem1,
  listItem2,
  listItem3,
  imageUrl,
  showImage,
}) => {
  const valuePropRows: { icon: LucideIconName; label: string }[] = [
    { icon: 'landmark', label: listItem1 },
    { icon: 'clipboard-check', label: listItem2 },
    { icon: 'mouse-pointer-click', label: listItem3 },
  ];

  return (
    <Flex
      direction='column'
      direction-lg='row'
      align='start'
      gap='lg'
      width='full'
      className='not-prose mx-auto w-full max-w-screen-2xl px-lg py-xl lg:items-center lg:justify-between'
    >
      <Flex
        direction='column'
        gap='md'
        width='full'
        className={showImage ? 'lg:max-w-[43%] lg:shrink-0' : undefined}
      >
        <Heading variant='h1' className='overflow-hidden text-ellipsis'>
          {header}
        </Heading>
        <Text variant='b3' className='hidden lg:block'>
          {desktopSubheader}
        </Text>
        <Text variant='b3' className='lg:hidden'>
          {mobileSubheader}
        </Text>
      </Flex>

      {showImage ? (
        <Flex
          direction='row'
          align='center'
          gap='sm'
          width='full'
          className='min-w-0 w-full flex-1 justify-start lg:justify-end md:gap-md'
        >
          <div className='-mr-section-break aspect-square w-editorial-listing-branding shrink-0 overflow-hidden rounded-lg'>
            <Image
              src={imageUrl}
              alt='Woman smiling in a cozy living room looking at her phone and laptop'
              className='h-full w-full object-cover'
            />
          </div>

          <ul className='flex min-w-0 flex-1 list-none flex-col items-end gap-xxs p-0 text-end max-w-72'>
            {valuePropRows.map(({ icon, label }) => (
              <li key={icon}>
                <ValueProp size='sm' icon={icon}>
                  <Text variant='b5' color='subtext' weight='semibold'>
                    {label}
                  </Text>
                </ValueProp>
              </li>
            ))}
          </ul>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default ResultsBanner;
